export default __webpack_public_path__ + "images/xmas_seamless_400.png";